module.exports = __webpack_public_path__ + "assets/img/leaf-idle.fe864543.png";